export enum TrainingTypeStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export const TrainingTypeStatusLabels: Record<TrainingTypeStatus, string> = {
  [TrainingTypeStatus.ACTIVE]: 'Ativo',
  [TrainingTypeStatus.INACTIVE]: 'Inativo',
};

export interface TrainingTypeData {
  id: number;
  name: string;
  description?: string | null;
  legalBasis?: string | null;
  workload?: number | null;
  periodicityMonths?: number | null;
  esocialCode?: string | null;
  certificateText?: string | null;
  status: TrainingTypeStatus;
  createdAt: string;
  updatedAt: string;
}

export interface TrainingTypeMinimal {
  id: number;
  name: string;
}

export interface TrainingTypeFormData {
  name: string;
  description?: string;
  legalBasis?: string;
  workload?: number | null;
  periodicityMonths?: number | null;
  esocialCode?: string;
  certificateText?: string;
  status: TrainingTypeStatus;
}

export interface TrainingTypeFilters {
  search?: string;
  status?: TrainingTypeStatus;
}

export interface TrainingTypeListResponse {
  trainingTypes: TrainingTypeData[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}
